import { useState } from 'react';
import { Card, TextInput, Button, Paper, Title, Text, Stack, Box, Group, ActionIcon } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconUser, IconLock, IconLogin, IconServer, IconArrowLeft } from '@tabler/icons-react';
import { login } from '../api';

interface LoginProps {
  onLogin: () => void;
  backendUrl: string;
  onBackToSetup: () => void;
}

export default function Login({ onLogin, backendUrl, onBackToSetup }: LoginProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await login(username, password);
      if (result.success) {
        notifications.show({
          title: 'Welcome back!',
          message: 'Loading your dashboard...',
          color: 'green',
          icon: <IconLogin size={16} />,
        });
        onLogin();
      } else {
        notifications.show({
          title: 'Login failed',
          message: 'Invalid username or password',
          color: 'red',
        });
      }
    } catch (err: any) {
      notifications.show({
        title: 'Error',
        message: err.message || 'Login failed',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  const displayHostname = backendUrl.replace(/^https?:\/\//, '').replace(/\/api$/, '');

  return (
    <Box style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <Card withBorder shadow="xl" padding="xl" radius="lg" w={450} style={{ backdropFilter: 'blur(10px)', background: 'rgba(255,255,255,0.95)' }}>
        <Group justify="space-between" mb="lg">
          <ActionIcon variant="subtle" onClick={onBackToSetup} size="lg">
            <IconArrowLeft size={20} />
          </ActionIcon>
          <Paper bg="blue.6" p="md" radius="xl">
            <IconServer size={32} color="white" />
          </Paper>
          <div style={{ width: 40 }} />
        </Group>
        
        <Stack align="center" mb="lg">
          <Title order={2}>Sinker DNS</Title>
          <Text size="sm" c="dimmed">Connected to: {displayHostname}</Text>
        </Stack>

        <form onSubmit={handleSubmit}>
          <Stack>
            <TextInput
              label="Username"
              placeholder="admin"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              leftSection={<IconUser size={16} />}
              required
              autoFocus
            />

            <TextInput
              label="Password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              leftSection={<IconLock size={16} />}
              required
            />

            <Button
              type="submit"
              loading={loading}
              variant="gradient"
              gradient={{ from: 'blue', to: 'cyan' }}
              fullWidth
              mt="md"
              size="lg"
            >
              Sign In
            </Button>
          </Stack>
        </form>
      </Card>
    </Box>
  );
}
